// extracted by mini-css-extract-plugin
module.exports = {"logo":"_29D0csI-CMAQsp3zlFWZjR"};